import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { SystemSection } from '../components/SystemSection';
import { BonusSection } from '../components/BonusSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-299">
      <HeroSection data-id="element-300" />
      <ForWhoSection data-id="element-301" />
      <PainSection data-id="element-302" />
      <BenefitsSection data-id="element-303" />
      <ProtocolSection data-id="element-304" />
      <TestimonialsSection data-id="element-305" />
      <SystemSection data-id="element-306" />
      <BonusSection data-id="element-307" />
      <OfferSection data-id="element-308" />
      <AboutSection data-id="element-309" />
      <FAQSection data-id="element-310" />
      <FinalCTASection data-id="element-311" />
    </main>;
}